import { createRequestTypes } from '../../utils';

// Action types
export const FETCH_MUSHROOM_CONTEXTS = createRequestTypes('FETCH_MUSHROOM_CONTEXTS');
export const FETCH_MUSHROOM_DETAIL = createRequestTypes('FETCH_MUSHROOM_DETAIL');
export const CLEAR_MUSHROOM_DETAIL = 'CLEAR_MUSHROOM_DETAIL';
export const CREATE_MUSHROOM_VARIETY = createRequestTypes('CREATE_MUSHROOM_VARIETY');
export const CREATE_MUSHROOM_HYBRID = createRequestTypes('CREATE_MUSHROOM_HYBRID');
export const UPDATE_MUSHROOM_CONTEXT = createRequestTypes('UPDATE_MUSHROOM_CONTEXT');
export const DELETE_MUSHROOM_CONTEXT = createRequestTypes('DELETE_MUSHROOM_CONTEXT');
export const UPLOAD_MUSHROOM_IMAGE = createRequestTypes('UPLOAD_MUSHROOM_IMAGE');

// Action creators
export const fetchMushroomContexts = (filters = {}) => ({
  type: FETCH_MUSHROOM_CONTEXTS.REQUEST,
  payload: filters,
});

export const fetchMushroomContextsSuccess = (data) => ({
  type: FETCH_MUSHROOM_CONTEXTS.SUCCESS,
  payload: data,
});

export const fetchMushroomContextsFailure = (error) => ({
  type: FETCH_MUSHROOM_CONTEXTS.FAILURE,
  payload: error,
});

// Create Variety
export const createMushroomVariety = (data) => ({
  type: CREATE_MUSHROOM_VARIETY.REQUEST,
  payload: data,
});

export const createMushroomVarietySuccess = (data) => ({
  type: CREATE_MUSHROOM_VARIETY.SUCCESS,
  payload: data,
});

export const createMushroomVarietyFailure = (error) => ({
  type: CREATE_MUSHROOM_VARIETY.FAILURE,
  payload: error,
});

// Create Hybrid
export const createMushroomHybrid = (data) => ({
  type: CREATE_MUSHROOM_HYBRID.REQUEST,
  payload: data,
});

export const createMushroomHybridSuccess = (data) => ({
  type: CREATE_MUSHROOM_HYBRID.SUCCESS,
  payload: data,
});

export const createMushroomHybridFailure = (error) => ({
  type: CREATE_MUSHROOM_HYBRID.FAILURE,
  payload: error,
});

// Update Mushroom Context
export const updateMushroomContext = (id, data) => ({
  type: UPDATE_MUSHROOM_CONTEXT.REQUEST,
  payload: { id, data },
});

export const updateMushroomContextSuccess = (data) => ({
  type: UPDATE_MUSHROOM_CONTEXT.SUCCESS,
  payload: data,
});

export const updateMushroomContextFailure = (error) => ({
  type: UPDATE_MUSHROOM_CONTEXT.FAILURE,
  payload: error,
});

// Delete Mushroom Context
export const deleteMushroomContext = (id) => ({
  type: DELETE_MUSHROOM_CONTEXT.REQUEST,
  payload: { id },
});

export const deleteMushroomContextSuccess = (id) => ({
  type: DELETE_MUSHROOM_CONTEXT.SUCCESS,
  payload: id,
});

export const deleteMushroomContextFailure = (error) => ({
  type: DELETE_MUSHROOM_CONTEXT.FAILURE,
  payload: error,
});

// Fetch Mushroom Detail
export const fetchMushroomDetail = (id, orgId) => ({
  type: FETCH_MUSHROOM_DETAIL.REQUEST,
  payload: { id, orgId },
});

export const fetchMushroomDetailSuccess = (data) => ({
  type: FETCH_MUSHROOM_DETAIL.SUCCESS,
  payload: data,
});

export const fetchMushroomDetailFailure = (error) => ({
  type: FETCH_MUSHROOM_DETAIL.FAILURE,
  payload: error,
});

// Clear Mushroom Detail
export const clearMushroomDetail = () => ({
  type: CLEAR_MUSHROOM_DETAIL,
});

// Fetch Species Spawn Lineage
export const FETCH_SPECIES_SPAWN_LINEAGE = createRequestTypes('FETCH_SPECIES_SPAWN_LINEAGE');
export const CLEAR_SPECIES_SPAWN_LINEAGE = 'CLEAR_SPECIES_SPAWN_LINEAGE';

export const fetchSpeciesSpawnLineage = (speciesId, orgId) => ({
  type: FETCH_SPECIES_SPAWN_LINEAGE.REQUEST,
  payload: { speciesId, orgId },
});

export const fetchSpeciesSpawnLineageSuccess = (data) => ({
  type: FETCH_SPECIES_SPAWN_LINEAGE.SUCCESS,
  payload: data,
});

export const fetchSpeciesSpawnLineageFailure = (error) => ({
  type: FETCH_SPECIES_SPAWN_LINEAGE.FAILURE,
  payload: error,
});

export const clearSpeciesSpawnLineage = () => ({
  type: CLEAR_SPECIES_SPAWN_LINEAGE,
});

// Upload Mushroom Image
export const uploadMushroomImage = (id, file) => ({
  type: UPLOAD_MUSHROOM_IMAGE.REQUEST,
  payload: { id, file },
});

export const uploadMushroomImageSuccess = (data) => ({
  type: UPLOAD_MUSHROOM_IMAGE.SUCCESS,
  payload: data,
});

export const uploadMushroomImageFailure = (error) => ({
  type: UPLOAD_MUSHROOM_IMAGE.FAILURE,
  payload: error,
});
